var _a;
import { loadStripe } from "@stripe/stripe-js";
import * as Sentry from "@sentry/react";
const STRIPE_KEY = ((_a = process.env.REACT_APP_STRIPE_KEY) !== null && _a !== void 0 ? _a : "pk_test_51PIdmNP9vjZnkbVHRC6rYPQA2CnIPWsGPbqimXu2DZxHKdtCnWVAmhzrocNyOdatUZltVG7e9ORuMRErxpN8DcdE00mB1Ob1s4").toString();
let stripeInstance = null;
let loadPromise = null;
let loadAttempts = 0;
async function attemptLoad(attempt) {
    try {
        const stripe = await loadStripe(STRIPE_KEY);
        if (stripe) {
            console.log(`[Stripe] Loaded successfully on attempt ${attempt}`);
            stripeInstance = stripe;
            return stripe;
        }
        Sentry.captureMessage("loadStripe resolved to null", {
            level: "warning",
            tags: { component: "stripeLoader", attempt: String(attempt) },
        });
        console.warn(`[Stripe] Attempt ${attempt} returned null`);
        return null;
    }
    catch (error) {
        Sentry.captureException(error, {
            tags: { component: "stripeLoader", attempt: String(loadAttempts) },
        });
        return null;
    }
}
/**
 * Loads Stripe.js with one retry. No artificial timeouts — loadStripe
 * handles the script loading internally. If both attempts fail, returns
 * null so the UI can show PayPal as alternative.
 */
async function load() {
    const first = await attemptLoad(1);
    if (first)
        return first;
    Sentry.captureMessage("Stripe first attempt failed — retrying once", {
        level: "warning",
        tags: { component: "stripeLoader" },
    });
    const retry = await attemptLoad(2);
    if (retry)
        return retry;
    Sentry.captureMessage("Stripe failed after 2 attempts", {
        level: "error",
        tags: { component: "stripeLoader" },
    });
    return null;
}
/**
 * Returns a promise that resolves to the Stripe instance or null.
 * - If already loaded, returns cached instance immediately.
 * - If a load is in progress, all callers share the same promise.
 * - Max 2 attempts total, no timeouts, no retry delays.
 */
export function preloadStripe() {
    if (stripeInstance)
        return Promise.resolve(stripeInstance);
    if (!loadPromise) {
        loadPromise = load();
    }
    return loadPromise;
}
/**
 * Returns the cached promise. If preloadStripe was never called it kicks off
 * the load now (backwards-compatible with the old module-level call).
 */
export function getStripePromise() {
    return preloadStripe();
}
